import { getIn } from 'formik'
import styles from './FormikErrors.module.scss'

export const FormikError = ({ formik, fieldName }) => {
  return (
    formik &&
    (getIn(formik.touched, fieldName) || formik.submitCount > 0) &&
    getIn(formik.errors, fieldName) && (
      <span className={styles['error']} role='alert'>
        {getIn(formik.errors, fieldName)}
      </span>
    )
  )
}
